import Pazienti from "../";

const routes = [
    { name: "PazientiList", path: "/pazienti", component: Pazienti.PazientiList, meta: { title: "pazienti.lblTitle" } },
    { name: "PazienteEdit", path: "/pazienti/edit/:id", component: Pazienti.PazientiEdit, meta: { title: "pazienti.lblTitle" } },
    { name: "PazientiProgettiList", path: "/progettipazienti", component: Pazienti.PazientiProgettiList, meta: { title: "pazienti.lblTitle" } },
    { name: "PazientiProgettiViewPage", path: "/progettipazienti/view/:id", component: Pazienti.PazientiProgettiViewPage, meta: { title: "pazienti.lblTitle" } },
    { name: "PazientiConsensiPage", path: "/paziente/consensi", component: Pazienti.PazienteConsensi, meta: { title: "Paziente Consensi" } },
];

export default routes;
